'use strict';
var parent = require('../../actual/number/is-finite');

module.exports = parent;
